import { Form, Input, Modal, Select, message } from "antd";
import { useState } from "react";
import { createInstitution } from "../../../../api/institutionApi";

const INSTITUTION_TYPE_OPTIONS = [
  { label: "Trading House", value: "TRADING_HOUSE" },
];

export default function InstitutionCreateModal({
  open,
  onClose,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      setSubmitting(true);

      await createInstitution({
        name: values.name?.trim(),
        type: values.type,
      });

      message.success("Байгууллага амжилттай үүслээ");
      form.resetFields();
      onSuccess?.();
      onClose?.();
    } catch (error) {
      if (error?.errorFields) return;
      message.error(
        error?.response?.data?.message || "Байгууллага үүсгэхэд алдаа гарлаа"
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  return (
    <Modal
      title="Байгууллага нэмэх"
      open={open}
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText="Үүсгэх"
      cancelText="Болих"
      confirmLoading={submitting}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Байгууллагын нэр"
          name="name"
          rules={[
            { required: true, message: "Байгууллагын нэр оруулна уу" },
            { min: 2, message: "Хамгийн багадаа 2 тэмдэгт байна" },
          ]}
        >
          <Input placeholder="Жишээ: Си Эф Си Групп" maxLength={150} />
        </Form.Item>

        <Form.Item
          label="Төрөл"
          name="type"
          rules={[{ required: true, message: "Төрөл сонгоно уу" }]}
          initialValue="TRADING_HOUSE"
        >
          <Select
            options={INSTITUTION_TYPE_OPTIONS}
            placeholder="Төрөл сонгох"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}